/* eslint-disable standard/object-curly-even-spacing */
/* eslint-disable indent */
import Entry from '../containers/Entry.vue'
// CFA考点管理
const testAddressMag = resolve => {
  require.ensure(
    ['../cfa/testAddressMag.vue'],
    require => {
      resolve(require('../cfa/testAddressMag.vue'))
    },
    'testAddressMag'
  )
}
// CFA考试费用管理
const testMoneyMag = resolve => {
  require.ensure(
    ['../cfa/testMoneyMag.vue'],
    require => {
      resolve(require('../cfa/testMoneyMag.vue'))
    },
    'testMoneyMag'
  )
}
// CFA报名列表
const applyList = resolve => {
  require.ensure(
    ['../cfa/applyList.vue'],
    require => {
      resolve(require('../cfa/applyList.vue'))
    },
    'applyList'
  )
}
// CF后台通用
const backGeneral = resolve => {
  require.ensure(
    ['../cfa/backGeneral.vue'],
    require => {
      resolve(require('../cfa/backGeneral.vue'))
    },
    'backGeneral'
  )
}
// ACCA报名列表
const accaApplyList = resolve => {
  require.ensure(
    ['../acca/accaApplyList.vue'],
    require => {
      resolve(require('../acca/accaApplyList.vue'))
    },
    'accaApplyList'
  )
}
// ACCA考点管理
const accaAdressMag = resolve => {
  require.ensure(
    ['../acca/accaAdressMag.vue'],
    require => {
      resolve(require('../acca/accaAdressMag.vue'))
    },
    'accaAdressMag'
  )
}
// ACCA考试时间管理
const accaTimeMag = resolve => {
  require.ensure(
    ['../acca/accaTimeMag.vue'],
    require => {
      resolve(require('../acca/accaTimeMag.vue'))
    },
    'accaTimeMag'
  )
}
// ACCA各考点费用管理
const accaMoneyMag = resolve => {
  require.ensure(
    ['../acca/accaMoneyMag.vue'],
    require => {
      resolve(require('../acca/accaMoneyMag.vue'))
    },
    'accaMoneyMag'
  )
}
// CMA报名列表
const CmaExaminfoList = resolve => {
  require.ensure(
    ['../components/CmaExaminfo/list.vue'],
    require => {
      resolve(require('../components/CmaExaminfo/list.vue'))
    },
    'CmaExaminfoList'
  )
}

// CMA操作记录
const CmaRecord = resolve => {
  require.ensure(
    ['../components/OPeration/record.vue'],
    require => {
      resolve(require('../components/OPeration/record.vue'))
    },
    'CmaRecord'
  )
}

// CMA成绩记录
const CmaGradeList = resolve => {
  require.ensure(
    ['../components/CmaExaminfo/grade.vue'],
    require => {
      resolve(require('../components/CmaExaminfo/grade.vue'))
    },
    'CmaGradeList'
  )
}

// CMA代报名配置
const CmaExaminfoRemark = resolve => {
  require.ensure(
    ['../components/CmaExaminfo/remark.vue'],
    require => {
      resolve(require('../components/CmaExaminfo/remark.vue'))
    },
    'CmaExaminfoRemark'
  )
}

// cma 代报名短信
const CmaExaminfoNote = resolve => {
  require.ensure(
    ['../components/CmaExaminfo/note.vue'],
    require => {
      resolve(require('../components/CmaExaminfo/note.vue'))
    },
    'CmaExaminfoNote'
  )
}

// cma 查看修改
const CmaExamCheck = resolve => {
  require.ensure(
    ['../components/CmaExaminfo/check.vue'],
    require => {
      resolve(require('../components/CmaExaminfo/check.vue'))
    },
    'CmaExamCheck'
  )
}

// CMA银行卡列表
const BankCardList = resolve => {
  require.ensure(
    ['../components/BankCard/list.vue'],
    require => {
      resolve(require('../components/BankCard/list.vue'))
    },
    'BankCardList'
  )
}

// CMA银行卡创建
const BankCardCreate = resolve => {
  require.ensure(
    ['../components/BankCard/create.vue'],
    require => {
      resolve(require('../components/BankCard/create.vue'))
    },
    'BankCardCreate'
  )
}

// CMA银行卡编辑
const BankCardEdit = resolve => {
  require.ensure(
    ['../components/BankCard/edit.vue'],
    require => {
      resolve(require('../components/BankCard/edit.vue'))
    },
    'BankCardEdit'
  )
}

// cma优惠列表
const CmaPreferentialList = resolve => {
  require.ensure(
    ['../components/CmaPreferential/list.vue'],
    require => {
      resolve(require('../components/CmaPreferential/list.vue'))
    },
    'CmaPreferentialList'
  )
}

// cma优惠列表
const CmaPreferentialCoupon = resolve => {
  require.ensure(
    ['../components/CmaPreferential/coupon.vue'],
    require => {
      resolve(require('../components/CmaPreferential/coupon.vue'))
    },
    'CmaPreferentialCoupon'
  )
}
// cma优惠创建
const CmaPreferentialCreate = resolve => {
  require.ensure(
    ['../components/CmaPreferential/create.vue'],
    require => {
      resolve(require('../components/CmaPreferential/create.vue'))
    },
    'CmaPreferentialCreate'
  )
}

// cma优惠编辑
const CmaPreferentialEdit = resolve => {
  require.ensure(
    ['../components/CmaPreferential/edit.vue'],
    require => {
      resolve(require('../components/CmaPreferential/edit.vue'))
    },
    'CmaPreferentialEdit'
  )
}

// CMA考试科目与时间列表
const CmaExamSubjectList = resolve => {
  require.ensure(
    ['../components/CmaExamSubject/list.vue'],
    require => {
      resolve(require('../components/CmaExamSubject/list.vue'))
    },
    'CmaExamSubjectList'
  )
}

// CMA考试科目与时间创建
const CmaExamSubjectCreate = resolve => {
  require.ensure(
    ['../components/CmaExamSubject/create.vue'],
    require => {
      resolve(require('../components/CmaExamSubject/create.vue'))
    },
    'CmaExamSubjectCreate'
  )
}

// CMA考试科目与时间编辑
const CmaExamSubjectEdit = resolve => {
  require.ensure(
    ['../components/CmaExamSubject/edit.vue'],
    require => {
      resolve(require('../components/CmaExamSubject/edit.vue'))
    },
    'CmaExamSubjectEdit'
  )
}

// 报名截止时间管理
const CmaExamSubjectDeadline = resolve => {
  require.ensure(
    ['../components/CmaExamSubject/deadline.vue'],
    require => {
      resolve(require('../components/CmaExamSubject/deadline.vue'))
    },
    'CmaExamSubjectDeadline'
  )
}

// CMA添加考试信息
const Message = resolve => {
  require.ensure(
    ['../components/CmaExamMessage/message.vue'],
    require => {
      resolve(require('../components/CmaExamMessage/message.vue'))
    },
    'Message'
  )
}

const Add = resolve => {
  require.ensure(
    ['../components/CmaExamMessage/add.vue'],
    require => {
      resolve(require('../components/CmaExamMessage/add.vue'))
    },
    'Add'
  )
}

// 代报名考试地址列表
const ExamAddressList = resolve => {
  require.ensure(
    ['../components/ExamAddress/list.vue'],
    require => {
      resolve(require('../components/ExamAddress/list.vue'))
    },
    'ExamAddressList'
  )
}

// 代报名考试地址创建
const ExamAddressCreate = resolve => {
  require.ensure(
    ['../components/ExamAddress/create.vue'],
    require => {
      resolve(require('../components/ExamAddress/create.vue'))
    },
    'ExamAddressCreate'
  )
}

// 代报名考试地址编辑
const ExamAddressEdit = resolve => {
  require.ensure(
    ['../components/ExamAddress/edit.vue'],
    require => {
      resolve(require('../components/ExamAddress/edit.vue'))
    },
    'ExamAddressEdit'
  )
}

// 登陆
const Login = resolve => {
  require.ensure(
    ['../containers/Login.vue'],
    require => {
      resolve(require('../containers/Login.vue'))
    },
    'Login'
  )
}

// 404
const Page404 = resolve => {
  require.ensure(
    ['../components/Page404.vue'],
    require => {
      resolve(require('../components/Page404.vue'))
    },
    'Page404'
  )
}

// 修改密码
const UpdatePwd = resolve => {
  require.ensure(
    ['../containers/UpdatePwd.vue'],
    require => {
      resolve(require('../containers/UpdatePwd.vue'))
    },
    'UpdatePwd'
  )
}

// 首页
const Home = resolve => {
  require.ensure(
    ['../containers/Home.vue'],
    require => {
      resolve(require('../containers/Home.vue'))
    },
    'Home'
  )
}

const AmacSignupList = resolve => {
  require.ensure(
    ['../amac/signuplist.vue'],
    require => {
      resolve(require('../amac/signuplist.vue'))
    },
    'AmacSignupList'
  )
}

const AmacSignupInfo = resolve => {
  require.ensure(
    ['../amac/signupInfo.vue'],
    require => {
      resolve(require('../amac/signupInfo.vue'))
    },
    'AmacSignupInfo'
  )
}

const AmacExamSubjectsList = resolve => {
  require.ensure(
    ['../amac/examSubjectsList.vue'],
    require => {
      resolve(require('../amac/examSubjectsList.vue'))
    },
    'AmacExamSubjectsList'
  )
}

const AmacTestSiteList = resolve => {
  require.ensure(
    ['../amac/testSiteList.vue'],
    require => {
      resolve(require('../amac/testSiteList.vue'))
    },
    'AmacTestSiteList'
  )
}

const AmacExamTimeList = resolve => {
  require.ensure(
    ['../amac/examTimeList.vue'],
    require => {
      resolve(require('../amac/examTimeList.vue'))
    },
    'AmacExamTimeList'
  )
}

// Frr
// 报名列表
const registrationList = resolve => {
  require.ensure(['../frr/registrationList.vue'], (require) => {
    resolve(require('../frr/registrationList.vue'))
  }, 'registrationList')
}
// 考试时间
const examTime = resolve => {
  require.ensure(['../frr/examTime.vue'], (require) => {
    resolve(require('../frr/examTime.vue'))
  }, 'examTime')
}
// 考试地址
const examSite = resolve => {
  require.ensure(['../frr/examSite.vue'], (require) => {
    resolve(require('../frr/examSite.vue'))
  }, 'examSite')
}
// 操作记录
const ctrlLog = resolve => {
  require.ensure(['../frr/ctrlLog.vue'], (require) => {
    resolve(require('../frr/ctrlLog.vue'))
  }, 'ctrlLog')
}


// FRM代报名
const FrmPage = resolve => {
  require.ensure(['../frm/page.vue'], (require) => {
    resolve(require('../frm/page.vue'))
  }, 'FrmPage')
}

// uscpa代报名
// 报名列表
const uscpa_orderlist = resolve => {
  require.ensure(['../uscpa/orderList.vue'], (require) => {
    resolve(require('../uscpa/orderList.vue'))
  }, 'uscpa_orderlist')
}
// 报名详情
const uscpa_orderdetail = resolve => {
  require.ensure(['../uscpa/orderDetail.vue'], (require) => {
    resolve(require('../uscpa/orderDetail.vue'))
  }, 'uscpa_orderdetail')
}
// 附件管理
const uscpa_annexmanage = resolve => {
  require.ensure(['../uscpa/annexManage.vue'], (require) => {
    resolve(require('../uscpa/annexManage.vue'))
  }, 'uscpa_annexmanage')
}

/** copyright li last change date 2019/10/29  */
//
const cfa_exammoney = resolve => {
  require.ensure(['../cfa/edit_exam_money.vue'], (require) => {
    resolve(require('../cfa/edit_exam_money.vue'))
  }, 'cfa_exammoney')
}

// 须知管理-须知列表
const knowsInfoList = resolve => {
  require.ensure(['../nows/knowsInfoList.vue'], (require) => {
    resolve(require('../nows/knowsInfoList.vue'))
  }, 'knowsInfoList')
}

const editKnows = resolve => {
  require.ensure(['../nows/edit_knows.vue'], (require) => {
    resolve(require('../nows/edit_knows.vue'))
  }, 'editKnows')
}

// acca考试时间
const accaExamTime = resolve => {
  require.ensure(['../acca/accaExamTime.vue'], (require) => {
    resolve(require('../acca/accaExamTime.vue'))
  }, 'accaExamTime')
}

// 导入记录
const importRecord = resolve => {
    require.ensure(['../acca/importRecord.vue'], (require) => {
        resolve(require('../acca/importRecord.vue'))
    }, 'importRecord')
}

// acca活动管理
const activitiesManagement = resolve => {
    require.ensure(['../acca/activitiesManagement.vue'], (require) => {
        resolve(require('../acca/activitiesManagement.vue'))
    }, 'activitiesManagement')
}

export const routes = [{
  path: '/',
  name: '5500',
  component: Entry,
  redirect: '/home',
  children: [
    { path: '/frr/registrationList', meta: { title: '报名列表' }, name: '1044', component: registrationList }, // 报名列表
    { path: '/frr/examTime', meta: { title: '考试时间' }, name: '1046', component: examTime }, // 考试时间
    { path: '/frr/examSite', meta: { title: '考试地址' }, name: '1045', component: examSite }, // 考试地址
    { path: '/frr/ctrlLog', meta: { title: '操作记录' }, name: '1047', component: ctrlLog }, // 操作记录
    { path: '/cma/examinfo/list', meta: { title: '代报名列表' }, name: 'CmaExaminfoList', component: CmaExaminfoList }, // 代报名列表
    { path: '/cma/examinfo/remark/:id', meta: { title: '代报名备注' }, name: 'CmaExaminfoRemark', component: CmaExaminfoRemark}, // 代报名备注
    { path: '/cma/operation/record', meta: { title: '代报名操作记录' }, name: 'CmaRecord', component: CmaRecord}, // 操作记录
    { path: '/cma/examinfo/grade', meta: { title: '成绩记录' }, name: 'CmaGradeList', component: CmaGradeList }, // 成绩记录
    { path: '/cma/examinfo/note/:id', meta: { title: '代报名短信' }, name: 'CmaExaminfoNote', component: CmaExaminfoNote}, // 代报名短信
    { path: '/cma/examinfo/check/:id', meta: { title: '查看 编辑报名表' }, name: 'CmaExamCheck', component: CmaExamCheck}, // 查看 编辑报名表

    { path: '/frm/register-list', meta: { title: '报名列表' }, name: 'FrmList', component: FrmPage }, // 报名列表
    { path: '/frm/exam-list', meta: { title: '考试信息' }, name: 'FrmExamList', component: FrmPage }, // 考试信息列表
    { path: '/frm/exam-list-create', meta: { title: '考试信息创建' }, name: 'FrmExamListCreate', component: FrmPage }, // 考试信息创建
    { path: '/frm/exam-list-edit/:id', meta: { title: '考试信息编辑' }, name: 'FrmExamListEdit', component: FrmPage }, // 考试信息编辑

    { path: '/nows/knowsInfoList', meta: { title: '须知列表' }, name: 'knowsInfoList', component: knowsInfoList}, // 查看 编辑报名表
    { path: '/nows/edit_knows', meta: { title: '须知' }, name: 'editKnows', component: editKnows}, // 查看 编辑报名表

    { path: '/cma/bankcard/list', meta: { title: '银行卡列表' }, name: 'BankCardList', component: BankCardList}, // 银行卡列表
    { path: '/cma/bankcard/create', meta: { title: '新增银行卡' }, name: 'BankCardCreat', component: BankCardCreate}, // 创建银行卡
    { path: '/cma/bankcard/edit/:id', meta: { title: '编辑银行卡' }, name: 'BankCardEdit', component: BankCardEdit}, // 编辑银行卡

    { path: '/cma/preferential/list', meta: { title: 'CMA优惠列表' }, name: 'CmaPreferentialList', component: CmaPreferentialList}, // CMA优惠列表
    { path: '/cma/preferential/coupon', meta: { title: 'CMA优惠券' }, name: 'CmaPreferentialCoupon', component: CmaPreferentialCoupon}, // CMA优惠码
    { path: '/cma/preferential/create', meta: { title: 'CMA优惠创建' }, name: 'CmaPreferentialCreate', component: CmaPreferentialCreate}, // CMA优惠创建
    { path: '/cma/preferential/edit/:id', meta: { title: 'CMA优惠编辑' }, name: 'CmaPreferentialEdit', component: CmaPreferentialEdit}, // CMA优惠编辑

    { path: '/cma/examsubject/list', meta: { title: 'CMA考试科目与时间' }, name: 'CmaExamSubjectList', component: CmaExamSubjectList}, // CMA考试科目与时间列表
    { path: '/cma/examsubject/create', meta: { title: 'CMA考试科目与时间添加' }, name: 'CmaExamSubjectCreate', component: CmaExamSubjectCreate}, // CMA考试科目与时间添加
    { path: '/cma/examsubject/edit/:id', meta: { title: 'CMA考试科目与时间编辑' }, name: 'CmaExamSubjectEdit', component: CmaExamSubjectEdit}, // CMA考试科目与时编辑
    { path: '/cma/examtime/deadline', meta: { title: 'CMA报名截止时间管理' }, name: 'CmaExamSubjectDeadline', component: CmaExamSubjectDeadline}, // CMA报名截止时间管理

    { path: '/acca/accaTimeMag', meta: { title: 'ACCA考试时间管理' }, name: 'accaTimeMag', component: accaTimeMag}, // ACCA考试时间管理
    { path: '/acca/accaAdressMag', meta: { title: 'ACCA考点管理' }, name: 'accaAdressMag', component: accaAdressMag}, // ACCA考点管理
    { path: '/acca/accaApplyList', meta: { title: 'ACCA报名列表' }, name: 'accaApplyList', component: accaApplyList}, // ACCA报名列表
    { path: '/acca/accaMoneyMag', meta: { title: 'ACCA各考点费用管理' }, name: 'accaMoneyMag', component: accaMoneyMag}, // ACCA各考点费用管理
    { path: '/acca/accaExamTime', meta: { title: 'ACCA考试时间' }, name: 'accaExamTime', component: accaExamTime}, // ACCA考试时间
    { path: '/acca/importRecord', meta: { title: '导入记录' }, name: 'importRecord', component: importRecord }, // 导入记录
    { path: '/acca/activitiesManagement', meta: { title: '活动管理' }, name: 'activitiesManagement', component: activitiesManagement }, // acca活动管理


    { path: '/cfa/testAddressMag', meta: { title: 'CFA考点管理' }, name: 'testAddressMag', component: testAddressMag}, // CFA考点管理
    { path: '/cfa/testMoneyMag', meta: { title: 'CFA考试费用管理' }, name: 'testMoneyMag', component: testMoneyMag}, // CFA考试费用管理
    { path: '/cfa/applyList', meta: { title: 'CFA报名列表' }, name: 'applyList', component: applyList}, // CFA报名列表
    { path: '/cfa/backGeneral', meta: { title: 'CFA后台通用' }, name: 'backGeneral', component: backGeneral}, // CFA后台通用
    { path: '/cfa/edit_exam_money', meta: { title: 'CFA新增考试信息' }, name: 'cfa_exammoney', component: cfa_exammoney}, // CFA后台通用

    { path: '/cma/exammessage/message', meta: { title: 'CMA考试信息' }, name: 'Message', component: Message}, // CMA考试信息
    { path: '/cma/exammessage/add', meta: { title: 'CMA考试信息添加' }, name: 'Add', component: Add}, // CMA考试信息添加

    { path: '/exam/address/list', meta: { title: '考点管理' }, name: 'ExamAddressList', component: ExamAddressList}, // 考点管理
    { path: '/exam/address/create', meta: { title: '考点添加' }, name: 'ExamAddressCreate', component: ExamAddressCreate}, // 考点添加
    { path: '/exam/address/edit/:id', meta: { title: '考点修改' }, name: 'ExamAddressEdit', component: ExamAddressEdit}, // 考点修改

    { path: '/amac/signuplist', meta: { title: '报名信息' }, name: 'AmacSignupList', component: AmacSignupList}, // 报名信息
    { path: '/amac/signupinfo/:id', meta: { title: '报名信息详情' }, name: 'AmacSignupInfo', component: AmacSignupInfo}, // 报名信息
    { path: '/amac/examSubjects', meta: { title: '考试科目管理'}, name: 'AmacExamSubjectsList', component: AmacExamSubjectsList}, // 考试科目管理
    { path: '/amac/testSite', meta: { title: '考点管理'}, name: 'AmacTestSiteList', component: AmacTestSiteList}, // 考点管理
    { path: '/amac/examTime', meta: { title: '考试时间管理'}, name: 'AmacExamTimeList', component: AmacExamTimeList}, // 考试时间管理

    { path: '/uscpa/orderList', meta: {title: 'USCPA报名列表'}, name: 'uscpa_orderlist', component: uscpa_orderlist}, // USCPA报名列表
    { path: '/uscpa/orderDetail', meta: {title: 'USCPA报名详情'}, name: 'uscpa_orderdetail', component: uscpa_orderdetail}, // USCPA报名详情
    { path: '/uscpa/annexManage', meta: {title: 'USCPA附件管理'}, name: 'uscpa_annexmanage', component: uscpa_annexmanage} // USCPA报名详情
  ]
},
{ path: '/login', meta: { title: '登陆' }, name: '10000', component: Login}, // 登陆
{ path: '*', meta: { title: '404' }, name: '10001', component: Page404 }, // 404
{ path: '/updatePwd', meta: { title: '修改密码' }, name: '10002', component: UpdatePwd}, // 修改密码
{ path: '/home', meta: { title: '财经云' }, name: '10003', component: Home } // 财经云
]



// WEBPACK FOOTER //
// ./src/js/routes/index.js